"use client";

import * as React from "react";

import { cn } from "@/utils/tailwind";

// Hook to check archival mode (lazy import to avoid circular deps)
let useArchivalModeHook: (() => { isArchivalMode: boolean }) | null = null;
try {
  const archivalContext = require("@/contexts/ArchivalModeContext");
  useArchivalModeHook = archivalContext.useArchivalMode;
} catch {
  // Context not available
}

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, disabled, ...props }, ref) => {
    // Check archival mode
    let isArchivalMode = false;
    try {
      if (useArchivalModeHook) {
        const archival = useArchivalModeHook();
        isArchivalMode = archival.isArchivalMode;
      }
    } catch {
      // Context not available
    }
    
    // Disable textarea in archival mode unless explicitly allowed
    const effectiveDisabled = disabled || (isArchivalMode && !props["data-allow-archival-edit"]);
    
    // Remove our custom data attribute before passing to native textarea
    const { "data-allow-archival-edit": _, ...restProps } = props;
    
    return (
      <textarea
        className={cn(
          "border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring flex min-h-[80px] w-full rounded-md border px-3 py-2 text-sm focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        ref={ref}
        disabled={effectiveDisabled}
        {...restProps}
      />
    );
  },
);
Textarea.displayName = "Textarea";

export { Textarea };
